import { EducationEnrollment, FigurLabProject, OrderSummary } from "../../types/store";

export const mockOrders: OrderSummary[] = [
    {
        id: "ORD-2059",
        date: "2025-11-03",
        total: 118,
        status: "COMPLETED",
        items: [
            { productName: "Aurora Texture Lab Vol. 03", productType: "TEXTURE", license: "COMMERCIAL", isDigital: true },
            { productName: "Mech Titan STL Bundle", productType: "STL", license: "PERSONAL", isDigital: true }
        ]
    },
    {
        id: "ORD-2044",
        date: "2025-10-21",
        total: 189,
        status: "DELIVERED",
        items: [
            { productName: "Concept Sculpt Resin Figure", productType: "PHYSICAL", isDigital: false }
        ]
    }
];

export const mockEducationEnrollments: EducationEnrollment[] = [
    {
        id: "EDU-XL",
        name: "Hard Surface Volumes Masterclass",
        progress: 72,
        ctaUrl: "/education/courses/hard-surface"
    },
    {
        id: "EDU-SPRINT",
        name: "Concept Sprint 2.0",
        progress: 34,
        ctaUrl: "/education"
    }
];

export const mockFigurLabProjects: FigurLabProject[] = [
    {
        id: "FIG-311",
        prompt: "Solar punk ranger with mechanical falcon",
        status: "MODELING",
        updatedAt: "2025-11-15"
    },
    {
        id: "FIG-299",
        prompt: "Architectural maquette for museum lobby",
        status: "READY_TO_PRINT",
        updatedAt: "2025-10-28"
    }
];
